import { omdApi } from '../../api';
import { FactoryFullNames } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getFactoryFullNames: builder.query<FactoryFullNames[], void>({
      query: () => ({
        url: '/v1/factory/fullNames',
      }),
    }),
  }),
});

export const { useLazyGetFactoryFullNamesQuery, useGetFactoryFullNamesQuery } = request;
